import { defineComponent, ref, inject, computed, onMounted, onBeforeUnmount, shallowRef, watch, triggerRef, nextTick, resolveComponent, resolveDirective, withDirectives, openBlock, createElementBlock, mergeProps, createElementVNode, createVNode, withCtx, createBlock, resolveDynamicComponent, normalizeProps, guardReactiveProps, createCommentVNode, createTextVNode, toDisplayString } from "vue";
import { t as toSubjectListString, D as DateTime } from "../helpers-674591c1.mjs";
import "../i18n-35335a5c.mjs";
import { g as getDisplayNameOfParticipant } from "../malarkeyTwilioAdapter-1c296255.mjs";
import "../index-64135f7d.mjs";
import { b as boundUseI18n } from "../_i18n-e414d464.mjs";
import "../event-socket/malarkeyEventSocketAdapter.es.js";
import { d as debug } from "../_debug-8b5c3032.mjs";
import "../otpauth.esm-675c01d0.mjs";
import "../sudo-bad5b55e.mjs";
import { a as acceptableFileTypes } from "../_common-fcf3ef61.mjs";
import { M as MalarkeyContactAvatar } from "../MalarkeyContactAvatar-1b079ba3.mjs";
import MalarkeyChatInputForm from "./constituants/MalarkeyChatInputForm.es.js";
import MalarkeyChatMessagePane from "./constituants/MalarkeyChatMessagePane.es.js";
import { V as VAvatar } from "../MalarkeyConversationListItem.vue_vue_type_script_lang-3da40755.mjs";
import { _ as _export_sfc } from "../_plugin-vue_export-helper-3194dc60.mjs";
import "joi";
import "../_commonjsHelpers-ca272635.mjs";
import "../index-38c53cf2.mjs";
import "../index-fd2245c5.mjs";
import "../index-13be80af.mjs";
import "../index-703c58ee.mjs";
import "../_density-8094aebe.mjs";
import "../theme-96176369.mjs";
import "../getCurrentInstance-eec76705.mjs";
import "../MalarkeyAttachmentPane.vue_vue_type_script_lang-d0f606dc.mjs";
import "../MPasswordField.vue_vue_type_script_lang-baf1023a.mjs";
import "../_VTextField-74fe2c1a.mjs";
import "../index-dbde2d54.mjs";
import "../_proxiedModel-031e293c.mjs";
import "../flow-501bd5ba.mjs";
import "../MalarkeyContactRosterItem.vue_vue_type_script_lang-89c5ac30.mjs";
import "../_VListItem-508e4b13.mjs";
import "../MalarkeyContactSearchItem.vue_vue_type_script_lang-f1ada97c.mjs";
const showOpenFilePicker = async (options) => {
  if (!window || !document) {
    throw new Error("showOpenFilePicker is only available in browser environments");
  }
  if (window && window.showOpenFilePicker) {
    return await window.showOpenFilePicker(options);
  }
  const opts = Object.assign(
    {},
    {
      excludeAcceptAllOption: false,
      multiple: false,
      types: []
    },
    options
  );
  let input;
  const ret = new Promise((resolve) => {
    input = document.createElement("input");
    input.type = "file";
    input.style.display = "none";
    if (opts.multiple)
      input.multiple = true;
    if (opts.types && opts.types.length) {
      input.accept = opts.types.map((type) => Object.keys(type.accept).join(",")).join(",");
    }
    input.addEventListener("change", (_e) => {
      if (!input) {
        return;
      }
      if (input.files && input.files.length) {
        const files = Array.from(input.files);
        const handles = files.map((file) => ({
          getFile: () => Promise.resolve(file),
          kind: "file",
          name: file.name
        }));
        resolve(handles);
      } else {
        resolve([]);
      }
    });
    input.addEventListener("error", (_e) => {
      resolve([]);
    });
    input.addEventListener("cancel", (_e) => {
      resolve([]);
    });
    document.body.appendChild(input);
    input.click();
  });
  const res = await ret;
  if (input) {
    document.body.removeChild(input);
  }
  if (opts.types && opts.types.length) {
    const acceptedExtensions = /* @__PURE__ */ new Set();
    opts.types.forEach((type) => {
      Object.keys(type.accept).forEach((key) => {
        type.accept[key].forEach((ext) => {
          acceptedExtensions.add(ext);
        });
      });
    });
    return res.filter((handle) => {
      const ext = handle.name.split(".").pop();
      return ext ? acceptedExtensions.has(`.${ext}`) : false;
    });
  }
  return res;
};
const _sfc_main = defineComponent({
  name: "MalarkeyChat",
  components: {
    VAvatar,
    MalarkeyContactAvatar,
    MalarkeyChatInputForm,
    MalarkeyChatMessagePane
  },
  props: {
    /**
     * The unique identifier for the conversation
     */
    sid: {
      type: String,
      default: void 0
    },
    /**
     * Show the close button in the header
     */
    showClose: {
      type: Boolean,
      default: false
    }
  },
  emits: {
    /**
     * Event emitted when the chat window close button is pressed
     */
    close: () => void 0
  },
  setup(props) {
    const hasFirstPreviewLoaded = ref(false);
    const { t } = boundUseI18n();
    const alert = inject("alert");
    const sid = computed(() => props.sid);
    const container = ref(null);
    const headerContainer = ref(
      null
    );
    const inputContainer = ref(
      null
    );
    const vuePrintMounted = ref(false);
    onMounted(() => {
      vuePrintMounted.value = true;
    });
    onBeforeUnmount(() => {
      vuePrintMounted.value = false;
    });
    const identity = inject("identity");
    const cron = inject("cron");
    const bus = inject("bus");
    const now = ref(void 0);
    const twilio = inject("twilio");
    const authenticated = computed(() => {
      if (!vuePrintMounted.value || !identity || !identity.booted.value) {
        return null;
      }
      if (!identity.authenticated.value) {
        return false;
      }
      return identity.authenticated.value;
    });
    const conversation = shallowRef(
      void 0
    );
    const participants = ref([]);
    const notificationLevel = ref(void 0);
    const lastUpdateAt = ref(void 0);
    const isMuted = computed(() => notificationLevel.value === "muted");
    const isGroupChat = computed(() => participants.value.length > 2);
    const nonUserParticipants = computed(
      () => (
        // @ts-ignore
        [...participants.value].filter(
          (p) => authenticated.value && p.identity !== identity.user.value.id
        )
      )
    );
    const avatarComponent = computed(
      () => isGroupChat.value ? "VAvatar" : "MalarkeyContactAvatar"
    );
    const avatarComponentParticipant = computed(
      () => isGroupChat.value ? null : nonUserParticipants.value[0]
    );
    const avatarComponentBindings = computed(() => {
      const basics = {
        size: 36
      };
      if (isGroupChat.value) {
        return {
          ...basics,
          icon: "mdi-account-group"
        };
      } else {
        return {
          ...basics,
          identity: "undefined" !== typeof avatarComponentParticipant.value && null !== avatarComponentParticipant.value ? avatarComponentParticipant.value.identity : void 0
        };
      }
    });
    const title = computed(() => {
      if (isGroupChat.value) {
        return toSubjectListString(
          nonUserParticipants.value.map((p) => getDisplayNameOfParticipant(p)).filter((d) => "string" === typeof d)
        );
      } else {
        return getDisplayNameOfParticipant(
          nonUserParticipants.value[0]
        );
      }
    });
    const actionMenuBindings = computed(() => ({
      closeOnBack: false,
      closeOnContentClick: false
    }));
    const onResetConversation = () => {
      participants.value = [];
      notificationLevel.value = void 0;
      lastUpdateAt.value = void 0;
      hasFirstPreviewLoaded.value = false;
    };
    const onConversationUpdated = async () => {
      if (!conversation.value) {
        participants.value = [];
        notificationLevel.value = void 0;
        lastUpdateAt.value = void 0;
        return;
      }
      notificationLevel.value = conversation.value.notificationLevel;
      if (conversation.value.lastMessage && conversation.value.lastMessage.dateCreated) {
        lastUpdateAt.value = DateTime.fromJSDate(
          conversation.value.lastMessage.dateCreated
        );
      } else if (conversation.value.dateUpdated) {
        lastUpdateAt.value = DateTime.fromJSDate(
          conversation.value.dateUpdated
        );
      } else if (conversation.value.dateCreated) {
        lastUpdateAt.value = DateTime.fromJSDate(
          conversation.value.dateCreated
        );
      } else {
        lastUpdateAt.value = void 0;
      }
      try {
        const list = await conversation.value.getParticipants();
        if (conversation.value && conversation.value.sid === sid.value) {
          participants.value = list;
        }
      } catch {
        participants.value = [];
      }
    };
    const updateConversationFromMain = () => {
      if (!sid.value || !twilio || !twilio.conversations.value) {
        conversation.value = void 0;
        onResetConversation();
        return;
      }
      conversation.value = twilio.conversations.value.find(
        (c) => c.sid === sid.value
      );
      triggerRef(conversation);
      if (conversation.value) {
        debug("Chat Window Conversation Updated");
        nextTick(() => {
          onConversationUpdated();
        });
      } else {
        onResetConversation();
      }
    };
    watch(() => sid.value, updateConversationFromMain, { immediate: true });
    const containerAvailableHeight = ref(void 0);
    const headerContainerHeight = ref(void 0);
    const inputContainerHeight = ref(void 0);
    const updateContainerAvailableHeight = (after) => {
      if (container.value) {
        containerAvailableHeight.value = container.value.clientHeight;
      }
      if (headerContainer.value) {
        headerContainerHeight.value = headerContainer.value.clientHeight;
      }
      if (inputForm.value) {
        inputContainerHeight.value = inputForm.value.$el.clientHeight + 8;
      }
      if ("function" === typeof after) {
        nextTick(() => {
          after();
        });
      }
    };
    const messagesPaneHeight = computed(() => {
      if (!containerAvailableHeight.value || !headerContainerHeight.value || !inputContainerHeight.value) {
        return "100%";
      }
      const remainder = containerAvailableHeight.value - headerContainerHeight.value - inputContainerHeight.value;
      return `${remainder}px`;
    });
    const containerBindings = computed(() => ({
      class: ["m-chat"],
      style: {
        position: "relative"
      }
    }));
    const headerBindings = computed(() => ({
      class: ["m-chat-header"]
    }));
    const windowBindings = computed(() => ({
      class: ["m-chat-window"],
      style: {
        height: messagesPaneHeight.value,
        minHeight: "min-content"
      }
    }));
    const inputContainerBindings = computed(() => ({
      class: ["m-chat-input-container", "d-flex", "align-end", "px-2", "py-1"]
    }));
    const recordingInputContainerBindings = computed(() => ({
      class: [
        "m-chat-recording-input-container",
        "d-flex",
        "align-end",
        "px-2",
        "py-1"
      ]
    }));
    const onCronTick = () => {
      now.value = DateTime.now();
    };
    const onTwilioClientConversationAdded = (c) => {
      if (c.sid === sid.value) {
        updateConversationFromMain();
      }
    };
    const onTwilioClientConversationJoined = (c) => {
      if (c.sid === sid.value) {
        updateConversationFromMain();
      }
    };
    const onTwilioClientConversationLeft = (c) => {
      if (c.sid === sid.value) {
        updateConversationFromMain();
      }
    };
    const onTwilioClientConversationRemoved = (c) => {
      if (c.sid === sid.value) {
        updateConversationFromMain();
      }
    };
    const onTwilioClientConversationUpdated = ({
      conversation: conversation2
    }) => {
      if (conversation2.sid === sid.value) {
        updateConversationFromMain();
      }
    };
    const setConversationMuted = () => {
      if (conversation.value) {
        conversation.value.setUserNotificationLevel("muted").catch(() => {
        });
      }
    };
    const setConversationUnmuted = () => {
      if (conversation.value) {
        conversation.value.setUserNotificationLevel("default").catch(() => {
        });
      }
    };
    const toggleMuted = () => {
      if (isMuted.value) {
        setConversationUnmuted();
      } else {
        setConversationMuted();
      }
    };
    const pendingAttachments = shallowRef(void 0);
    const handlePendingAttachments = () => {
      triggerRef(pendingAttachments);
      if (bus && conversation.value && Array.isArray(pendingAttachments.value) && pendingAttachments.value.length > 0) {
        bus.emit(
          "attachments:ready",
          {
            local: true
          },
          conversation.value,
          pendingAttachments.value
        );
        nextTick(() => {
          pendingAttachments.value = void 0;
          triggerRef(pendingAttachments);
        });
      }
    };
    const onAttachFile = async () => {
      if (typeof window === "undefined") {
        console.error(t("errors.attach.window"));
        return;
      }
      if (!showOpenFilePicker) {
        if (alert) {
          alert(
            "errors.attach.filepicker.title",
            "errors.attach.filepicker.text"
          );
        } else {
          window.alert(t("errors.attach.filepicker.title"));
        }
        return;
      }
      const handleIdFull = `conversation-${conversation.value ? conversation.value.sid : "unknown"}-attachment-file`;
      const handleIdSub = handleIdFull.substring(0, 32);
      let handles;
      try {
        handles = await showOpenFilePicker({
          excludeAcceptAllOption: true,
          id: handleIdSub,
          multiple: true,
          startIn: "documents",
          types: [
            {
              description: t("malarkeyChat.attachments.file"),
              accept: {
                "image/bmp": [".bmp"],
                "image/tiff": [".tif", ".tiff"],
                "text/vcard": [".vcf"],
                "text/x-vcard": [".vcf"],
                "text/csv": [".csv"],
                "text/rtf": [".rtf"],
                "text/richtext": [".rtx"],
                "text/calendar": [".ics"],
                "text/directory": [],
                // usually no specific file extension
                "application/pdf": [".pdf"],
                "application/vcard": [".vcf"],
                "application/vnd.apple.pkpass": [".pkpass"],
                "application/msword": [".doc"],
                "application/vnd.ms-excel": [".xls"],
                "application/vnd.ms-powerpoint": [".ppt"],
                "application/vnd.openxmlformats-officedocument.presentationml.presentation": [".pptx"],
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"]
              }
            }
          ]
        });
      } catch (e) {
        debug("Failed to open file picker dialog", e);
        return;
      }
      if (!handles || handles.length === 0) {
        return;
      }
      const files = await Promise.all(
        handles.map(async (h) => {
          return h.getFile();
        })
      );
      if (!Array.isArray(pendingAttachments.value)) {
        pendingAttachments.value = [];
      }
      files.forEach((f) => {
        pendingAttachments.value.push(f);
      });
      handlePendingAttachments();
    };
    const onAttachVisual = async () => {
      if (typeof window === "undefined") {
        console.error(t("errors.attach.window"));
        return;
      }
      if (!showOpenFilePicker) {
        if (alert) {
          alert(
            "errors.attach.filepicker.title",
            "errors.attach.filepicker.text"
          );
        } else {
          window.alert(t("errors.attach.filepicker.title"));
        }
        return;
      }
      const handleIdFull = `conversation-${conversation.value ? conversation.value.sid : "unknown"}-attachment-visual`;
      const handleIdSub = handleIdFull.substring(0, 32);
      let handles;
      try {
        handles = await showOpenFilePicker({
          excludeAcceptAllOption: true,
          id: handleIdSub,
          multiple: true,
          startIn: "pictures",
          types: [
            {
              description: t("malarkeyChat.attachments.visual"),
              accept: {
                "image/png": [".png"],
                "image/jpeg": [".jpg", ".jpeg"],
                "image/gif": [".gif"],
                "video/mpeg": [".mpg", ".mpeg"],
                "video/mp4": [".mp4"],
                "video/quicktime": [".mov"],
                "video/webm": [".webm"],
                "video/3gpp": [".3gp"],
                "video/3gpp2": [".3g2"],
                "video/3gpp-tt": [],
                "video/H261": [".h261"],
                "video/H263": [".h263"],
                "video/H263-1998": [],
                "video/H263-2000": [],
                "video/H264": [".h264"]
              }
            }
          ]
        });
      } catch (e) {
        debug("Failed to open file picker dialog", e);
        return;
      }
      if (!handles || handles.length === 0) {
        return;
      }
      const files = await Promise.all(
        handles.map(async (h) => {
          return h.getFile();
        })
      );
      if (!Array.isArray(pendingAttachments.value)) {
        pendingAttachments.value = [];
      }
      files.forEach((f) => {
        console.log(f);
        pendingAttachments.value.push(f);
      });
      handlePendingAttachments();
    };
    const onAttachAudio = async () => {
      if (typeof window === "undefined") {
        console.error(t("errors.attach.window"));
        return;
      }
      if (!showOpenFilePicker) {
        if (alert) {
          alert(
            "errors.attach.filepicker.title",
            "errors.attach.filepicker.text"
          );
        } else {
          window.alert(t("errors.attach.filepicker.title"));
        }
        return;
      }
      const handleIdFull = `conversation-${conversation.value ? conversation.value.sid : "unknown"}-attachment-audio`;
      const handleIdSub = handleIdFull.substring(0, 32);
      let handles;
      try {
        handles = await showOpenFilePicker({
          excludeAcceptAllOption: true,
          id: handleIdSub,
          multiple: true,
          startIn: "music",
          types: [
            {
              description: t("malarkeyChat.attachments.audio"),
              accept: {
                "audio/basic": [".au", ".snd"],
                "audio/L24": [".l24"],
                "audio/mp4": [".mp4"],
                "audio/mpeg": [".mp3"],
                "audio/vnd.rn-realaudio": [".ra"],
                "audio/vnd.wave": [".wav"],
                "audio/3gpp": [".3gp"],
                "audio/3gpp2": [".3g2"],
                "audio/ac3": [".ac3"],
                "audio/webm": [".webm"],
                "audio/amr-nb": [".amr"],
                "audio/amr": [".amr"],
                "audio/aac": [".aac"],
                "audio/ogg": [".opus", ".ogg"]
              }
            }
          ]
        });
      } catch (e) {
        debug("Failed to open file picker dialog", e);
        return;
      }
      if (!handles || handles.length === 0) {
        return;
      }
      const files = await Promise.all(
        handles.map(async (h) => {
          return h.getFile();
        })
      );
      if (!Array.isArray(pendingAttachments.value)) {
        pendingAttachments.value = [];
      }
      files.forEach((f) => {
        pendingAttachments.value.push(f);
      });
      handlePendingAttachments();
    };
    const onDocumentPaste = (e) => {
      if (!e.clipboardData) {
        return;
      }
      const items = e.clipboardData.items;
      if (!items) {
        return;
      }
      const files = [];
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.kind === "file") {
          const file = item.getAsFile();
          if (file) {
            if (acceptableFileTypes.includes(file.type)) {
              files.push(file);
            }
          }
        }
      }
      if (!Array.isArray(pendingAttachments.value)) {
        pendingAttachments.value = [];
      }
      files.forEach((f) => {
        pendingAttachments.value.push(f);
      });
      handlePendingAttachments();
    };
    const isDraggingAttachment = ref(false);
    const onDragEnter = () => {
      isDraggingAttachment.value = true;
    };
    const onDragLeave = (event) => {
      if (!container.value) {
        isDraggingAttachment.value = false;
        return;
      }
      const rect = container.value.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX >= rect.right || event.clientY < rect.top || event.clientY >= rect.bottom) {
        isDraggingAttachment.value = false;
      }
    };
    const onDrop = (e) => {
      debug("Intercepted Container Drop Event");
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      isDraggingAttachment.value = false;
      if (!e.dataTransfer) {
        return;
      }
      const files = Array.from(e.dataTransfer.files);
      if (!Array.isArray(pendingAttachments.value)) {
        pendingAttachments.value = [];
      }
      files.forEach((f) => {
        if (acceptableFileTypes.includes(f.type)) {
          pendingAttachments.value.push(f);
        }
      });
      handlePendingAttachments();
      return false;
    };
    const onWindowDrop = (e) => {
      debug("Intercepted Window Drop Event");
      if (!container.value) {
        return;
      }
      const rect = container.value.getBoundingClientRect();
      if (e.clientX >= rect.left && e.clientX < rect.right && e.clientY >= rect.top && e.clientY < rect.bottom) {
        onDrop(e);
      }
    };
    const showDropZone = computed(() => isDraggingAttachment.value);
    const dropZoneBindings = computed(() => ({
      class: ["m-chat-drop-zone", "align-center", "justify-center"],
      contained: true,
      attach: container.value,
      modelValue: showDropZone.value
    }));
    const showRecordingDialog = ref(false);
    const onRecordMessage = () => {
      showRecordingDialog.value = true;
    };
    const onTrashRecording = () => {
      showRecordingDialog.value = false;
    };
    const updateContainerAvailableHeightFromBus = () => {
      updateContainerAvailableHeight();
    };
    const showingVirtualKeyboard = ref(false);
    const onVirtualKeyboardChange = (is) => {
      showingVirtualKeyboard.value = is === true;
    };
    onMounted(() => {
      if (cron) {
        onCronTick();
        cron.$on("* * * * * *", onCronTick);
      }
      if (bus) {
        bus.on(
          "twilio:client:conversationAdded",
          onTwilioClientConversationAdded,
          { local: true }
        );
        bus.on(
          "twilio:client:conversationJoined",
          onTwilioClientConversationJoined,
          { local: true }
        );
        bus.on(
          "twilio:client:conversationLeft",
          onTwilioClientConversationLeft,
          { local: true }
        );
        bus.on(
          "twilio:client:conversationRemoved",
          onTwilioClientConversationRemoved,
          { local: true }
        );
        bus.on(
          "twilio:client:conversationUpdated",
          onTwilioClientConversationUpdated,
          { local: true }
        );
        bus.on("tab:active", updateContainerAvailableHeightFromBus, {
          local: true
        });
        bus.on("tab:inactive", updateContainerAvailableHeightFromBus, {
          local: true
        });
        bus.on("window:resized", updateContainerAvailableHeightFromBus, {
          local: true
        });
        bus.on("virtualkeyboard:change", onVirtualKeyboardChange, {
          local: true
        });
      }
      updateContainerAvailableHeight();
      if (typeof window !== "undefined") {
        window.addEventListener(
          "resize",
          updateContainerAvailableHeightFromBus
        );
      }
      if (document) {
        document.addEventListener("paste", onDocumentPaste);
        document.addEventListener("drop", onWindowDrop);
      }
    });
    onBeforeUnmount(() => {
      if (cron) {
        cron.$off("* * * * * *", onCronTick);
      }
      if (bus) {
        bus.off(
          "twilio:client:conversationAdded",
          onTwilioClientConversationAdded,
          { local: true }
        );
        bus.off(
          "twilio:client:conversationJoined",
          onTwilioClientConversationJoined,
          { local: true }
        );
        bus.off(
          "twilio:client:conversationLeft",
          onTwilioClientConversationLeft,
          { local: true }
        );
        bus.off(
          "twilio:client:conversationRemoved",
          onTwilioClientConversationRemoved,
          { local: true }
        );
        bus.off(
          "twilio:client:conversationUpdated",
          onTwilioClientConversationUpdated,
          { local: true }
        );
        bus.off("tab:active", updateContainerAvailableHeightFromBus, {
          local: true
        });
        bus.off("tab:inactive", updateContainerAvailableHeightFromBus, {
          local: true
        });
        bus.off("window:resized", updateContainerAvailableHeightFromBus, {
          local: true
        });
        bus.off("virtualkeyboard:change", onVirtualKeyboardChange, {
          local: true
        });
      }
      if (typeof window !== "undefined") {
        window.removeEventListener(
          "resize",
          updateContainerAvailableHeightFromBus
        );
      }
      if (document) {
        document.removeEventListener("paste", onDocumentPaste);
        document.removeEventListener("drop", onWindowDrop);
      }
    });
    const isActive = computed(() => conversation.value !== void 0);
    const isArchived = computed(
      () => conversation.value === void 0 || typeof conversation.value.state === "undefined" || conversation.value.state.current !== "active"
    );
    const inputForm = ref(null);
    const showSubmitInsteadOfRecord = computed(
      () => "undefined" !== typeof inputForm.value && null !== inputForm.value && true === inputForm.value.hasContents
    );
    const formIsSubmitting = computed(
      () => inputForm.value && inputForm.value.isSubmitting
    );
    const onSubmitClick = () => {
      if (inputForm.value) {
        inputForm.value.doFormSubmit();
      }
    };
    const messagePane = ref(null);
    const scrollToLatest = () => {
      if (messagePane.value) {
        messagePane.value.scrollToLatest();
      }
    };
    const onFieldResize = () => {
      updateContainerAvailableHeight(() => {
        scrollToLatest();
      });
    };
    const onPreviewLoaded = () => {
      console.log("onPreviewLoaded", hasFirstPreviewLoaded.value);
      hasFirstPreviewLoaded.value = true;
    };
    return {
      containerBindings,
      headerBindings,
      windowBindings,
      inputContainerBindings,
      recordingInputContainerBindings,
      avatarComponent,
      avatarComponentBindings,
      title,
      actionMenuBindings,
      isMuted,
      showRecordingDialog,
      toggleMuted,
      onAttachFile,
      onAttachVisual,
      onAttachAudio,
      onRecordMessage,
      onTrashRecording,
      conversation,
      inputForm,
      showSubmitInsteadOfRecord,
      formIsSubmitting,
      onSubmitClick,
      isActive,
      container,
      headerContainer,
      inputContainer,
      updateContainerAvailableHeight,
      participants,
      messagePane,
      onFieldResize,
      onDragEnter,
      onDragLeave,
      onDrop,
      dropZoneBindings,
      scrollToLatest,
      onPreviewLoaded,
      isArchived,
      showingVirtualKeyboard
    };
  }
});
const _hoisted_1 = ["textContent"];
const _hoisted_2 = { class: "m-chat-drop-zone--content-outer" };
const _hoisted_3 = { class: "m-chat-drop-zone--content-inner" };
const _hoisted_4 = ["textContent"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_list_item = resolveComponent("v-list-item");
  const _component_v_card = resolveComponent("v-card");
  const _component_v_menu = resolveComponent("v-menu");
  const _component_v_toolbar_items = resolveComponent("v-toolbar-items");
  const _component_v_list_item_title = resolveComponent("v-list-item-title");
  const _component_MalarkeyChatMessagePane = resolveComponent("MalarkeyChatMessagePane");
  const _component_MalarkeyChatInputForm = resolveComponent("MalarkeyChatInputForm");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_alert = resolveComponent("v-alert");
  const _component_v_slide_x_transition = resolveComponent("v-slide-x-transition");
  const _component_v_overlay = resolveComponent("v-overlay");
  const _directive_mutate = resolveDirective("mutate");
  const _directive_intersect = resolveDirective("intersect");
  const _directive_resize = resolveDirective("resize");
  return withDirectives((openBlock(), createElementBlock("div", mergeProps({ ref: "container" }, _ctx.containerBindings, {
    onDragenter: _cache[1] || (_cache[1] = (...args) => _ctx.onDragEnter && _ctx.onDragEnter(...args)),
    onDragleave: _cache[2] || (_cache[2] = (...args) => _ctx.onDragLeave && _ctx.onDragLeave(...args)),
    onMouseleave: _cache[3] || (_cache[3] = (...args) => _ctx.onDragLeave && _ctx.onDragLeave(...args)),
    onDrop: _cache[4] || (_cache[4] = (...args) => _ctx.onDrop && _ctx.onDrop(...args))
  }), [
    createElementVNode("div", mergeProps({ ref: "headerContainer" }, _ctx.headerBindings), [
      createVNode(_component_v_list_item, { class: "ps-2 pe-0" }, {
        prepend: withCtx(() => [
          (openBlock(), createBlock(resolveDynamicComponent(_ctx.avatarComponent), normalizeProps(guardReactiveProps(_ctx.avatarComponentBindings)), null, 16))
        ]),
        append: withCtx(() => [
          createVNode(_component_v_toolbar_items, null, {
            default: withCtx(() => [
              _ctx.isActive && !_ctx.isArchived ? (openBlock(), createBlock(_component_v_menu, normalizeProps(mergeProps({ key: 0 }, _ctx.actionMenuBindings)), {
                activator: withCtx(({ props }) => [
                  createVNode(_component_v_btn, mergeProps(props, { icon: "mdi-dots-vertical" }), null, 16)
                ]),
                default: withCtx(() => [
                  createVNode(_component_v_card, null, {
                    default: withCtx(() => [
                      _ctx.isMuted ? (openBlock(), createBlock(_component_v_list_item, {
                        key: 0,
                        onClick: _ctx.toggleMuted,
                        "prepend-icon": "mdi-volume-high",
                        title: _ctx.$t("malarkeyChat.tooltips.unmute")
                      }, null, 8, ["onClick", "title"])) : (openBlock(), createBlock(_component_v_list_item, {
                        key: 1,
                        onClick: _ctx.toggleMuted,
                        "prepend-icon": "mdi-volume-off",
                        title: _ctx.$t("malarkeyChat.tooltips.mute")
                      }, null, 8, ["onClick", "title"]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 16)) : createCommentVNode("", true),
              _ctx.showClose ? (openBlock(), createBlock(_component_v_btn, {
                key: 1,
                icon: "mdi-close",
                onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("close"))
              })) : createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        default: withCtx(() => [
          createVNode(_component_v_list_item_title, null, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(_ctx.title), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ], 16),
    createElementVNode("div", mergeProps({ ref: "inputContainer" }, _ctx.windowBindings), [
      createVNode(_component_MalarkeyChatMessagePane, {
        ref: "messagePane",
        conversation: _ctx.conversation,
        participants: _ctx.participants,
        archived: _ctx.isArchived,
        "onPreview:loaded": _ctx.onPreviewLoaded
      }, null, 8, ["conversation", "participants", "archived", "onPreview:loaded"])
    ], 16),
    !_ctx.isArchived ? (openBlock(), createElementBlock("div", normalizeProps(mergeProps({ key: 0 }, _ctx.inputContainerBindings)), [
      createVNode(_component_v_menu, null, {
        activator: withCtx(({ props }) => [
          createVNode(_component_v_btn, mergeProps(props, {
            icon: "mdi-plus",
            density: "compact",
            variant: "flat",
            size: "large"
          }), null, 16)
        ]),
        default: withCtx(() => [
          createVNode(_component_v_card, { "min-height": "30" }, {
            default: withCtx(() => [
              createVNode(_component_v_list_item, {
                "prepend-icon": "mdi-file",
                title: _ctx.$t("malarkeyChat.attachments.file"),
                onClick: _ctx.onAttachFile
              }, null, 8, ["title", "onClick"]),
              createVNode(_component_v_list_item, {
                "prepend-icon": "mdi-image-multiple",
                title: _ctx.$t("malarkeyChat.attachments.visual"),
                onClick: _ctx.onAttachVisual
              }, null, 8, ["title", "onClick"]),
              createVNode(_component_v_list_item, {
                "prepend-icon": "mdi-headphones",
                title: _ctx.$t("malarkeyChat.attachments.audio"),
                onClick: _ctx.onAttachAudio
              }, null, 8, ["title", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      createVNode(_component_MalarkeyChatInputForm, {
        ref: "inputForm",
        conversation: _ctx.conversation,
        onResize: _ctx.onFieldResize
      }, null, 8, ["conversation", "onResize"]),
      !_ctx.showingVirtualKeyboard ? (openBlock(), createBlock(_component_v_btn, {
        key: 0,
        icon: "",
        onClick: _ctx.onSubmitClick,
        density: "compact",
        variant: "elevated",
        size: "large",
        loading: _ctx.formIsSubmitting,
        color: _ctx.showSubmitInsteadOfRecord ? "success" : void 0,
        disabled: !_ctx.showSubmitInsteadOfRecord
      }, {
        default: withCtx(() => [
          createVNode(_component_v_icon, { size: "small" }, {
            default: withCtx(() => [
              createTextVNode("mdi-send")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClick", "loading", "color", "disabled"])) : createCommentVNode("", true),
      createVNode(_component_v_slide_x_transition, null, {
        default: withCtx(() => [
          _ctx.showRecordingDialog ? (openBlock(), createElementBlock("div", normalizeProps(mergeProps({ key: 0 }, _ctx.recordingInputContainerBindings)), [
            createVNode(_component_v_btn, {
              icon: "mdi-trash-can-outline",
              onClick: _ctx.onTrashRecording,
              density: "compact",
              variant: "flat",
              size: "large"
            }, null, 8, ["onClick"]),
            createVNode(_component_v_alert, {
              type: "warning",
              density: "compact"
            }, {
              default: withCtx(() => [
                createTextVNode("Not Yet Enabled")
              ]),
              _: 1
            })
          ], 16)) : createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 16)) : (openBlock(), createBlock(_component_v_alert, {
      key: 1,
      color: "info",
      icon: "mdi-archive",
      rounded: 0,
      density: "compact"
    }, {
      default: withCtx(() => [
        createElementVNode("span", {
          textContent: toDisplayString(_ctx.$t("malarkeyChat.info.archived"))
        }, null, 8, _hoisted_1)
      ]),
      _: 1
    })),
    createVNode(_component_v_overlay, mergeProps(_ctx.dropZoneBindings, { onDrop: _ctx.onDrop }), {
      default: withCtx(() => [
        createElementVNode("div", _hoisted_2, [
          createElementVNode("div", _hoisted_3, [
            createElementVNode("span", {
              textContent: toDisplayString(_ctx.$t("malarkeyChat.actions.dropFileHere"))
            }, null, 8, _hoisted_4)
          ])
        ])
      ]),
      _: 1
    }, 16, ["onDrop"])
  ], 16)), [
    [
      _directive_mutate,
      _ctx.updateContainerAvailableHeight,
      void 0,
      {
        attr: true,
        child: true,
        immediate: true
      }
    ],
    [_directive_intersect, { handler: _ctx.updateContainerAvailableHeight }],
    [_directive_resize, _ctx.updateContainerAvailableHeight]
  ]);
}
const MalarkeyChat = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "MalarkeyChat.vue"]]);
export {
  MalarkeyChat as default
};
//# sourceMappingURL=MalarkeyChat.es.js.map
